import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs/operators';

import { GetGroup } from '@libs/src/groups/groups-store/groups.actions';
import { GroupsState } from '@libs/src/groups/groups-store/groups.interfaces';
import { Group } from '@libs/src/models/group.model';
import { AppState } from '@main-client/src/app/app.interfaces';

import find from 'lodash-es/find';

@Injectable()
export class GroupsStoreService {
  constructor(private store: Store<AppState>) {}

  getGroupFromStore(group: Group) {
    return this.store.select('groups').pipe(
      map((state: GroupsState[]) =>
        find(state, {
          document: group._id ? { _id: group._id } : { slug: group.slug },
        }),
      ),
      tap((groupState: GroupsState) => {
        if (!groupState) {
          this.store.dispatch(GetGroup({ group }));
        }
      }),
      filter((groupState: GroupsState) => !!groupState),
    );
  }
}
